
@if (this.show()) {

  <kendo-dialog (close)="onClose()" [width]="720">

    <kendo-dialog-titlebar class="title-bar">
      Select an Organization
    </kendo-dialog-titlebar>

    <section>

      <summary>
            This resource requires you to choose an organization on AMS in order to access its capabilities.
      </summary>

      @if(this.isSystemUser) {

          <!-- USING COMBOBOX ASYNC WITH NO DELAY - Works - could add minimum length -->
          <kendo-combobox
                class="dropdown-default"
                #combobox
                [data]="accounts$ | async"
                valueField="accountId"
                textField="display"
                placeholder="Search For An Organization"
                [filterable]="true" 
                (filterChange)="onFilterChange($event)"
                (valueChange)="onSearchAccountSelect($event)"
                [loading]="isLoadingSearch"
                rounded="full"
                [popupSettings]="{ popupClass: 'popup-default change-account-popup', width: 360, height: 200 }"
                >
          </kendo-combobox>

          <!-- <kendo-combobox
              class="dropdown-default"
              #combobox
              [data]="accounts"
              valueField="accountId"
              textField="display"
              placeholder="Search For An Organization"
              [filterable]="true" 
              (valueChange)="onSearchAccountSelect($event)"
              rounded="full"
              [popupSettings]="{ popupClass: 'popup-default' }">
          </kendo-combobox> -->
      }

      @if (hasGridOverflow()) {
        <kendo-grid 
            class="default change-account-grid"
            [height]="getGridHeight()"
            [selectable]="{ mode: 'single' }"
            [kendoGridBinding]="this.userData?.accounts"
            kendoGridSelectBy="accountId"
            [(selectedKeys)]="selectedKeys"
            [sortable]="true"
            width="100%"
            (selectionChange)="onAccountSelect($event)">
                <kendo-grid-checkbox-column [width]="36" [class]="'gridCell'"></kendo-grid-checkbox-column>
                <kendo-grid-column field="name" title="Organization" [class]="'accountCell'"></kendo-grid-column>
                <kendo-grid-column field="city" title="City" [class]="'gridCell'" [width]="110"></kendo-grid-column>
                <kendo-grid-column field="state" title="State" [class]="'gridCell'" [width]="82"></kendo-grid-column>
                <kendo-grid-column field="serialNumber" title="Serial #" [class]="getSerialColumnClass()" [width]="100"></kendo-grid-column>
        </kendo-grid>
      } @else {
        <kendo-grid 
            class="default change-account-grid"
            [selectable]="{ mode: 'single' }"
            [kendoGridBinding]="this.userData?.accounts"
            kendoGridSelectBy="accountId"
            [(selectedKeys)]="selectedKeys"
            [sortable]="true"
            width="100%"
            (selectionChange)="onAccountSelect($event)">
                <kendo-grid-checkbox-column [width]="36" [class]="'gridCell'"></kendo-grid-checkbox-column>
                <kendo-grid-column field="name" title="Organization" [class]="'accountCell'"></kendo-grid-column>
                <kendo-grid-column field="city" title="City" [class]="'gridCell'" [width]="110"></kendo-grid-column>
                <kendo-grid-column field="state" title="State" [class]="'gridCell'" [width]="82"></kendo-grid-column>
                <kendo-grid-column field="serialNumber" title="Serial #" [class]="getSerialColumnClass()" [width]="100"></kendo-grid-column>
        </kendo-grid>
      }

      <div class="note">
        *AMS has expired
      </div>

    </section>

    <kendo-dialog-actions class="default" layout="start">

      <button class="default grey" kendoButton (click)="onCancel()" size="large" rounded="full">
          Cancel
      </button>

      <button
          class="default softproblue"
          kendoButton
          themeColor="primary"
          [disabled]="isDisabled"
          (click)="onConfirm()" size="large" rounded="full">
          @if (this.isLoaderVisible) {
            <kendo-loader type="pulsing" size="small" themeColor="light">
            </kendo-loader>
          }
          Apply
      </button>

    </kendo-dialog-actions>

  </kendo-dialog>

}

